import React, { useState } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import { geoCentroid } from "d3-geo";

// URL to TopoJSON data for US states
const geoUrl = require("./states-10m.json");

// Mapping of state names to their abbreviations
const stateAbbreviations = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

const USAMapSVG = ({ selectedState, onStateClick, locations }) => {
  const [hoveredState, setHoveredState] = useState(null);

  const availableStates = new Set(locations.map((loc) => loc.state));

  

  return (
    // <ComposableMap projection="geoAlbersUsa" width={850} height={500}>
    <ComposableMap projection="geoAlbersUsa" width={850} height={500} viewBox="0 0 850 500">

    <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies.map((geo) => {
            const centroid = geoCentroid(geo);
            const stateName = geo.properties.name;
            const stateAbbr = stateAbbreviations[stateName];
            {/* const stateSlug =  stateName.toLowerCase(); */}
            const stateSlug = stateName.toLowerCase().replace(/\s+/g, "-");

            const hasData = availableStates.has(stateName); // Check if state has locations
            const isSelected = selectedState === stateSlug;
            const isHovered = hoveredState === stateName && hasData ;
            

            return (
              <g
                key={geo.rsmKey}
                onMouseEnter={() => hasData  && setHoveredState(stateName)}
                onMouseLeave={() => hasData && setHoveredState(null)}
                style={{ cursor: hasData ? "pointer" : "default" }}
              >
                <Geography
                  geography={geo}
                  fill={
                    isSelected
                      ? "#bb363f"
                      : isHovered
                      ? "#bb363f"
                      : hasData
                      ? "#EAEAEC"
                      : "#d3d3d3" // Grey out states without data
                  }
                  stroke="#303030"
                  style={{
                    default: { outline: "none" },
                    hover: hasData
                      ? { fill: "#bb363f", outline: "none" }
                      : { fill: "#d3d3d3", outline: "none" }, // Keep disabled states grey
                    pressed: { fill: "#bb363f", outline: "none" },
                  }}
                  onClick={() => hasData && onStateClick(stateSlug)}
                />
                {stateAbbr && centroid && centroid.length === 2 && !isNaN(centroid[0]) && !isNaN(centroid[1]) && (
  <Marker coordinates={[centroid[0], centroid[1]]}>
    <text
      textAnchor="middle"
      alignmentBaseline="central"
      style={{ pointerEvents: "none", userSelect: "none" }}
      fill={isSelected || isHovered ? "#fff" : hasData ? "#000" : "#aaa"}
      fontSize={14}
      strokeWidth={0}  // Ensure no stroke is applied (Safari can misbehave here)
    >
      {stateAbbr}
    </text>
  </Marker>
)}

                {/* {stateAbbr && centroid[0] && centroid[1] && (
                  <Marker coordinates={centroid}>
                    <text
                      textAnchor="middle"
                      alignmentBaseline="central"
                      style={{ pointerEvents: "none" }}
                      fill={isSelected || isHovered ? "#fff" : hasData ? "#000" : "#aaa"} // Grey out disabled states
                      fontSize={14}
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      paintOrder="stroke"
                    >
                      {stateAbbr}
                    </text>
                  </Marker>
                )} */}
              </g>
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
};

export default USAMapSVG;
